import cn from 'classnames';
import defaultImg from '../../../../assets/image/newShop/defaultImg.png';

interface IPrimaryCardArProps {
  title: string;
  image?: string;
  onClick?: () => void;
  active: boolean;
  disabled?: boolean;
  desc?: string;
}

const PrimaryCardAR = ({
  title,
  image,
  active,
  onClick,
  disabled,
  desc,
}: IPrimaryCardArProps) => {
  const handleClick = () => {
    !disabled && onClick && onClick();
  };

  return (
    <div
      onClick={handleClick}
      className={cn(
        'flex flex-col justify-center items-center h-[120px] py-2 rounded-lg shadow-sm ',
        {'border-2 !border-farm-shop-500 bg-farm-shop-50': active},
        {'bg-gray-100 grayscale': disabled},
      )}
    >
      <img className="w-[60px]" src={image || defaultImg} alt="" />
      <span className="mt-2 text-md text-gray-950">{title}</span>
      <span className="text-xs text-gray-700">{desc}</span>
    </div>
  );
};

export default PrimaryCardAR;
